import React from 'react'
import PropTypes from 'prop-types'

import FacebookIcon from '!!@svgr/webpack!media/facebook-logo.svg'
import TwitterIcon from '!!@svgr/webpack!media/twitter-logo.svg'
import PinterestIcon from '!!@svgr/webpack!media/pinterest-logo.svg'
import { isSSR } from 'js/isSSR'

class ShareButtons extends React.Component {
  static propTypes = {
    title: PropTypes.string,
  }
  popup(e) {
    e.preventDefault()

    const url = e.currentTarget.getAttribute('href')
    const title = e.currentTarget.textContent

    const w = 580
    const h = 470

    // Fixes dual-screen position                            Most browsers       Firefox
    const dualScreenLeft =
      window.screenLeft !== undefined ? window.screenLeft : screen.left
    const dualScreenTop =
      window.screenTop !== undefined ? window.screenTop : screen.top

    const width = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth
      ? document.documentElement.clientWidth
      : screen.width
    const height = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight
      ? document.documentElement.clientHeight
      : screen.height

    const left = width / 2 - w / 2 + dualScreenLeft
    const top = height / 3 - h / 3 + dualScreenTop

    const newWindow = window.open(
      url,
      title,
      'scrollbars=yes, width=' +
        w +
        ', height=' +
        h +
        ', top=' +
        top +
        ', left=' +
        left
    )

    // Puts focus on the newWindow
    if (newWindow && newWindow.focus) {
      newWindow.focus()
    }
  }

  render = () => {
    if (isSSR) return null
    return (
      <div className="c-share">
        <h2 className="c-share__heading">Share this post</h2>
        <ul className="c-share__list">
          <li className="c-share__item c-share__item--facebook">
            <a
              className="c-share__button"
              href={`https://www.facebook.com/sharer/sharer.php?u=${document.location.href}`}
              onClick={this.popup}
            >
              <FacebookIcon className="c-share__icon" />
              <span className="c-share__text">Facebook</span>
            </a>
          </li>
          <li className="c-share__item c-share__item--twitter">
            <a
              className="c-share__button"
              href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
                this.props.title.split(' – ').pop()
              )}+${document.location.href}+%40Lifesum`}
              onClick={this.popup}
            >
              <TwitterIcon className="c-share__icon" />
              <span className="c-share__text">Twitter</span>
            </a>
          </li>
          <li className="c-share__item c-share__item--pinterest">
            <a
              className="c-share__button"
              href={`http://pinterest.com/pin/create/button/?url=${
                document.location.href
              }&description=${this.props.title.split(' – ').pop()}`}
              onClick={this.popup}
            >
              <PinterestIcon className="c-share__icon" />
              <span className="c-share__text">Save</span>
            </a>
          </li>
        </ul>
      </div>
    )
  }
}

export default ShareButtons
